import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Figure1 from '../../assets/svg/figure-1.svg';
import Figure2 from '../../assets/svg/figure-2.svg';
import { Image } from '..';
import './Layout.scss';
import NotificationsModal from '../NotificationsModal';
import {
  checkNewNotifications,
  closeNotificationModal,
  getNotificationsByUser,
} from '../../core/notifications/action';

export default function Layout({ children }) {
  const dispatch = useDispatch();
  const { openModal, notifications } = useSelector((state) => state.notifications);
  const { user } = useSelector((state) => state.users);

  const closeNotificationsModal = () => {
    dispatch(closeNotificationModal());
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (process.env.REACT_APP_DISABLE_NOTIFICATIONS) return;
      if (!user?.id) return;
      dispatch(getNotificationsByUser(user.id));
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, user]);

  useEffect(() => {
    dispatch(checkNewNotifications());
  }, [dispatch, notifications]);

  return (
    <div className="dashboard-layout">
      {children}
      <NotificationsModal isOpen={openModal} handleClose={closeNotificationsModal} />

      <Image className="figure-1" src={Figure1} alt="" />
      <Image className="figure-2" src={Figure2} alt="" />
      <Image className="figure-3" src={Figure2} alt="" />
      <Image className="figure-4" src={Figure2} alt="" />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
